import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";

export function parsePositiveInteger(value: string | null): number | null {
    if (!value) {
        return null;
    }
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function parseLedgerBasis(
    value: string | null,
): AccountingLedgerBasis | undefined {
    switch (value) {
        case AccountingLedgerBasis.cash:
            return AccountingLedgerBasis.cash;
        case AccountingLedgerBasis.accruals:
            return AccountingLedgerBasis.accruals;
        default:
            return undefined;
    }
}

export function transactionOpenPath(transactionId: number): string {
    const filters = encodeURIComponent(
        JSON.stringify({ transactionIds: [transactionId] }),
    );
    return `/transactions?filters=${filters}`;
}

export function journalEntryOpenPath(options: {
    entityId: number;
    journalEntryId: string;
    ledgerBasis?: AccountingLedgerBasis;
    ledgerId?: string;
    workspaceId?: string;
    searchParams?: URLSearchParams;
}): string {
    const params = new URLSearchParams(options.searchParams);
    params.set("entityId", options.entityId.toString());
    if (options.ledgerBasis) {
        params.set("ledgerBasis", options.ledgerBasis);
    }
    if (options.ledgerId) {
        params.set("ledgerId", options.ledgerId);
    }
    if (options.workspaceId) {
        params.set("workspaceId", options.workspaceId);
    }
    return `/accounting/general-ledger/journal-entries/${encodeURIComponent(
        options.journalEntryId,
    )}?${params.toString()}`;
}
